import { PageHeaderToolbar } from 'components/PageContainer/PageHeaderToolbar';
import { UserStatusChip } from 'components/UserStatusChip';

import { StudentProfileMenu } from './StudentProfileMenu';

interface StudentProfileToolbarProps {
  userId: string;
  isActive: boolean;
  needsOnboarding?: boolean;
  onboardingSentAt?: string | null;
  activatedAt?: string | null;
}

/**
 * Toolbar for student profile page header.
 * Contains the user status badge and actions menu.
 */
export function StudentProfileToolbar({
  userId,
  isActive,
  needsOnboarding,
  onboardingSentAt,
  activatedAt,
}: StudentProfileToolbarProps) {
  return (
    <PageHeaderToolbar>
      <UserStatusChip
        isActive={isActive}
        needsOnboarding={needsOnboarding}
        onboardingSentAt={onboardingSentAt}
        activatedAt={activatedAt}
      />
      <StudentProfileMenu
        userId={userId}
        needsOnboarding={needsOnboarding}
        onboardingSentAt={onboardingSentAt}
        activatedAt={activatedAt}
      />
    </PageHeaderToolbar>
  );
}

export default StudentProfileToolbar;
